import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from './icons';
import styles from './Modal.module.scss';

export function Modal({
  children,
  onClose,
}: {
  children: ReactNode;
  onClose?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.modal}>
      <div className={styles.content}>
        {onClose && (
          <button
            type="button"
            className={styles.close}
            onClick={onClose}
            aria-label={t('Close')}
          >
            <CloseIcon className={styles.closeIcon} />
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
